const CATEGORY_MATCHERS = {
  Committees: (category) => category?.includes('Committee'),
  Commons: (category) => category === 'House of Commons',
  Lords: (category) => category === 'House of Lords',
  'Westminster Hall': (category) => category === 'Westminster Hall',
};

const filterTranscriptsByCategory = (items, activeSection) => {
  if (activeSection === 'All') return items;
  if (activeSection === 'Other') {
    return items.filter((item) => !Object.values(CATEGORY_MATCHERS).some((matches) => matches(item.eventCategory)));
  }
  const matches = CATEGORY_MATCHERS[activeSection];
  return matches ? items.filter((item) => matches(item.eventCategory)) : items;
};

export default filterTranscriptsByCategory;
